var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c(
      "form",
      {
        staticClass: "m-form m-form--state",
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.submitForm.apply(null, arguments)
          }
        }
      },
      [
        _c("div", { staticClass: "modal-body" }, [
          _c(
            "div",
            { staticClass: "m-portlet__body" },
            [
              _c(
                "div",
                {
                  staticClass: "form-group m-form__group",
                  class: { "has-danger": _vm.errors.has("name_type") }
                },
                [
                  _c("label", { attrs: { for: "name_type" } }, [
                    _vm._v(
                      _vm._s(_vm._f("capitalize")(_vm._f("translate")("name")))
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.authorized_type.name,
                        expression: "authorized_type.name"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|min:2|max:70",
                        expression: "'required|min:2|max:70'"
                      }
                    ],
                    ref: "name",
                    staticClass: "form-control m-input",
                    attrs: {
                      type: "text",
                      id: "name_type",
                      name: "name_type",
                      placeholder: _vm._f("capitalize")(
                        _vm._f("translate")("enter_name")
                      )
                    },
                    domProps: { value: _vm.authorized_type.name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.authorized_type,
                          "name",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("name_type"),
                          expression: "errors.has('name_type')"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [_vm._v(" " + _vm._s(_vm.errors.first("name_type")) + " ")]
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "m-form__group form-group" }, [
                _c("label", { attrs: { for: "" } }, [
                  _vm._v(
                    _vm._s(_vm._f("capitalize")(_vm._f("translate")("options")))
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "m-checkbox-list" }, [
                  _c(
                    "label",
                    { staticClass: "m-checkbox m-checkbox--state-brand" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.authorized_type.staff_transfer,
                            expression: "authorized_type.staff_transfer"
                          }
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(
                            _vm.authorized_type.staff_transfer
                          )
                            ? _vm._i(_vm.authorized_type.staff_transfer, null) >
                              -1
                            : _vm.authorized_type.staff_transfer
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.authorized_type.staff_transfer,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.authorized_type,
                                    "staff_transfer",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.authorized_type,
                                    "staff_transfer",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.authorized_type,
                                "staff_transfer",
                                $$c
                              )
                            }
                          }
                        }
                      }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("capitalize")(
                              _vm._f("translate")("staff_transfer")
                            )
                          ) +
                          "\n              "
                      ),
                      _c("span")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "m-checkbox m-checkbox--state-brand" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.authorized_type.portal_operator,
                            expression: "authorized_type.portal_operator"
                          }
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(
                            _vm.authorized_type.portal_operator
                          )
                            ? _vm._i(
                                _vm.authorized_type.portal_operator,
                                null
                              ) > -1
                            : _vm.authorized_type.portal_operator
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.authorized_type.portal_operator,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.authorized_type,
                                    "portal_operator",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.authorized_type,
                                    "portal_operator",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.authorized_type,
                                "portal_operator",
                                $$c
                              )
                            }
                          }
                        }
                      }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("capitalize")(
                              _vm._f("translate")("portal_operator")
                            )
                          ) +
                          "\n              "
                      ),
                      _c("span")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "m-checkbox m-checkbox--state-brand" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.authorized_type.is_responsible,
                            expression: "authorized_type.is_responsible"
                          }
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(
                            _vm.authorized_type.is_responsible
                          )
                            ? _vm._i(_vm.authorized_type.is_responsible, null) >
                              -1
                            : _vm.authorized_type.is_responsible
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.authorized_type.is_responsible,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.authorized_type,
                                    "is_responsible",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.authorized_type,
                                    "is_responsible",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.authorized_type,
                                "is_responsible",
                                $$c
                              )
                            }
                          }
                        }
                      }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("capitalize")(
                              _vm._f("translate")("is_responsible")
                            )
                          ) +
                          "\n              "
                      ),
                      _c("span")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "m-checkbox m-checkbox--state-brand" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.authorized_type.is_visitor,
                            expression: "authorized_type.is_visitor"
                          }
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.authorized_type.is_visitor)
                            ? _vm._i(_vm.authorized_type.is_visitor, null) > -1
                            : _vm.authorized_type.is_visitor
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.authorized_type.is_visitor,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.authorized_type,
                                    "is_visitor",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.authorized_type,
                                    "is_visitor",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.authorized_type, "is_visitor", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("capitalize")(
                              _vm._f("translate")("is_visitor")
                            )
                          ) +
                          "\n              "
                      ),
                      _c("span")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "m-checkbox m-checkbox--state-brand" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.authorized_type.own_fleet,
                            expression: "authorized_type.own_fleet"
                          }
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.authorized_type.own_fleet)
                            ? _vm._i(_vm.authorized_type.own_fleet, null) > -1
                            : _vm.authorized_type.own_fleet
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.authorized_type.own_fleet,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.authorized_type,
                                    "own_fleet",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.authorized_type,
                                    "own_fleet",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.authorized_type, "own_fleet", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("capitalize")(
                              _vm._f("translate")("own_fleet")
                            )
                          ) +
                          "\n              "
                      ),
                      _c("span")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "m-checkbox m-checkbox--state-brand" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.authorized_type.is_cargo,
                            expression: "authorized_type.is_cargo"
                          }
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.authorized_type.is_cargo)
                            ? _vm._i(_vm.authorized_type.is_cargo, null) > -1
                            : _vm.authorized_type.is_cargo
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.authorized_type.is_cargo,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.authorized_type,
                                    "is_cargo",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.authorized_type,
                                    "is_cargo",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.authorized_type, "is_cargo", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("capitalize")(
                              _vm._f("translate")("is_cargo")
                            )
                          ) +
                          "\n              "
                      ),
                      _c("span")
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group m-form__group row" }, [
                _c("div", { staticClass: "col-lg-3" }, [
                  _c("div", { staticClass: "input-group-btn" }, [
                    _vm._v(",\n              "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary dropdown-toggle",
                        attrs: {
                          "data-toggle": "dropdown",
                          "aria-haspopup": "true",
                          "aria-expanded": "false"
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("capitalize")(_vm._f("translate")("add"))
                            ) +
                            " "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "dropdown-menu",
                        attrs: { "x-placement": "top-start" }
                      },
                      [
                        _vm._l(_vm.documents, function(doc) {
                          return _c(
                            "a",
                            {
                              key: doc.id,
                              staticClass: "dropdown-item item-action",
                              on: {
                                click: function($event) {
                                  return _vm.add(doc)
                                }
                              }
                            },
                            [_vm._v(_vm._s(doc.name))]
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item item-action",
                            attrs: {
                              "data-toggle": "modal",
                              "data-backdrop": "static",
                              "data-keyboard": "false",
                              "data-target": "#documents_modal"
                            },
                            on: {
                              click: function($event) {
                                return _vm.setStatusDocumentModal(true)
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "fa fa-plus-circle" }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("capitalize")(
                                    _vm._f("translate")("create_document")
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ],
                      2
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-lg-9" }, [
                  _c("label", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("label", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("capitalize")(
                            _vm._f("translate")("add_documents")
                          )
                        ) +
                        " "
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm._l(_vm.documentsAdded, function(item) {
                return _c(
                  "div",
                  { key: item.id, staticClass: "form-group m-form__group row" },
                  [
                    _c("div", { staticClass: "col-lg-5" }, [
                      _c("input", {
                        staticClass: "form-control m-input",
                        attrs: { type: "text", disabled: "" },
                        domProps: { value: item.name }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-lg-3 checkbox-centered" }, [
                      _c("label", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("label", { staticClass: "m-checkbox" }, [
                        _c("input", {
                          attrs: { id: item.name, type: "checkbox" },
                          on: {
                            click: [
                              function($event) {
                                return _vm.requirednew()
                              },
                              function($event) {
                                return _vm.required(item)
                              }
                            ]
                          }
                        }),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("capitalize")(
                                _vm._f("translate")("required")
                              )
                            ) +
                            "\n              "
                        ),
                        _c("span")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-lg-2" }, [
                      _c(
                        "a",
                        {
                          staticClass:
                            "btn btn-outline-danger m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill",
                          attrs: { href: "" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.remove(item)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-trash" })]
                      )
                    ])
                  ]
                )
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.is_condominium === "true",
                      expression: "is_condominium === 'true'"
                    }
                  ],
                  staticClass: "form-group m-form__group",
                  class: { "has-danger": _vm.errors.has("name_type") }
                },
                [
                  _c("label", { attrs: { for: "name_type" } }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("capitalize")(_vm._f("translate")("range_time"))
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.authorized_type.range_time,
                        expression: "authorized_type.range_time"
                      }
                    ],
                    ref: "range_time",
                    staticClass: "form-control m-input",
                    attrs: {
                      type: "text",
                      id: "range_time",
                      name: "range_time",
                      placeholder: _vm._f("capitalize")(
                        _vm._f("translate")("range_time")
                      )
                    },
                    domProps: { value: _vm.authorized_type.range_time },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.authorized_type,
                          "range_time",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("range_time"),
                          expression: "errors.has('range_time')"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [_vm._v(" " + _vm._s(_vm.errors.first("range_time")) + " ")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-group m-form__group",
                  class: {
                    "has-danger": _vm.errors.has("validity_authorization")
                  }
                },
                [
                  _c("div", { staticClass: "col-lg-3" }, [
                    _c("label", { attrs: { for: "validity_authorization" } }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("capitalize")(
                            _vm._f("translate")("validity_authorization")
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.authorized_type.validity_authorization,
                            expression: "authorized_type.validity_authorization"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        ref: "validity_authorization",
                        staticClass: "form-control m-input",
                        attrs: {
                          type: "text",
                          id: "validity_authorization",
                          name: "validity_authorization",
                          placeholder: _vm._f("capitalize")(
                            _vm._f("translate")("days")
                          )
                        },
                        domProps: {
                          value: _vm.authorized_type.validity_authorization
                        },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.authorized_type,
                              "validity_authorization",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group-append" }, [
                        _c("span", { staticClass: "input-group-text" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(_vm._f("translate")("days"))
                            )
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("validity_authorization"),
                            expression: "errors.has('validity_authorization')"
                          }
                        ],
                        staticClass: "m-form__help m--font-danger"
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.errors.first("validity_authorization")) +
                            " "
                        )
                      ]
                    )
                  ])
                ]
              )
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modal-footer" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-secondary",
              attrs: {
                type: "button",
                "data-dismiss": "modal",
                id: "btn-cancel"
              },
              on: { click: _vm.resetForm }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("capitalize")(_vm._f("translate")("cancel"))) +
                  "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: { type: "submit" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.submitForm.apply(null, arguments)
                }
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("capitalize")(_vm._f("translate")("submit"))) +
                  "\n      "
              )
            ]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a020df3c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a020df3c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/admin/authorized/authorized_types/New.vue
// module id = 423
// module chunks = 0 1 64 170